<template>
    <div class="el-row-home" id="home">
        <!-- <LeaderPage v-if="role=='ROLE_JYZX_USER'"></LeaderPage>
        <dailyOffice v-if="role=='ROLE_JYZXSH_USER'"></dailyOffice> -->
        <dailyOffice />
    </div>
</template>

<script>
import { mapState } from "vuex";
import LeaderPage from "./components/leader-page.vue";
import dailyOffice from "./components/daily-office.vue";
import { apiIndex } from '@/server/common';

export default {
    components: {
        LeaderPage,
        dailyOffice
    },
    data() {
        return {
            tableMaxHeight: document.documentElement.clientHeight - 650,
            dialogVisible: false,
            typeId: '',//角色类型
            loginInfor: '',//登录信息
            addr: '',//登录地址
            username: '',//用户名
            userPerms: "admin",
            resource: '',
            pageIndex: 1,
            pageSize: 7,
            total: 5,
            role: "",
        }
    },
    computed: {
        ...mapState({
            stateData: state => state.user
        })
    },
    filters: {

    },
    created() {
        // 解决第一次登陆后返回按钮 go(-1)，路由更改页面不刷新的bug
        if (window.sessionStorage.getItem("appFirstInit") == undefined) {
            window.sessionStorage.setItem("appFirstInit", 'first');
            window.location.reload();
        }
    },
    activated() {

        this.loginInfor = this.stateData.attributes //登录信息
        this.username = this.stateData.username //用户名
    },
    mounted() {
        const that = this;
        let resizeTag = true
        if (this.stateData.supperAdmin) {
            this.role = 'ROLE_JYZX_USER';
            // this.$store.commit('user/updateRole', this.role)
        } else {
            apiIndex().then(({ data }) => {
                if (data.code == '1') {
                    this.role = data.data;
                    // this.$store.commit('user/updateRole', this.role)
                } else if (data.code === '1003' || data.code === '1001') {
                    this.$router.push({ name: 'login' })
                }
            })
        }
        window.onresize = () => {
            if (resizeTag) { //防抖动
                that.ifmove();
                resizeTag = false
                setTimeout(() => {
                    resizeTag = true
                }, 1000)
            }
        }
        that.ifmove()

        if (!this.stateData.supperAdmin) {
            this.getUserPer()
        }

    },
    methods: {

        getUserPer() {



        },


        ifmove() {

            if (document.documentElement.clientHeight > 900) {
                this.tableMaxHeight = document.documentElement.clientHeight - 650;
            } else if (document.documentElement.clientHeight < 770) {
                this.tableMaxHeight = document.documentElement.clientHeight - 480
            } else {
                this.tableMaxHeight = document.documentElement.clientHeight - 525
            }

        },


    },
}
</script>
<style lang="less">
#home {

    ul,
    li {
        margin: 0;
        padding: 0;
    }
}

ul li {
    list-style: none
}

.el-row-home {
    width: 100%;
    // height: 100%;

    .el-card__body {
        padding: 0;
    }

    .el-top {
        height: 50%;
    }

    .el-bottom {
        margin-bottom: 20px;
    }

    .tit_head {
        font-size: 16px;
        width: 100%;
        border-bottom: 1px solid rgba(229, 232, 236, 1);
        box-sizing: border-box;
        padding: 15px;

        p {
            border-left: 3px solid #1965FF;
            padding-left: 10px;
            margin: 0;
            color: #343434;
            font-weight: 400;
        }
    }

    .el-main {
        padding: 10px 20px;

        @media screen and (max-width: 1440px) {
            .owner {
                .mediaPic {
                    width: 60px;
                    height: 60px;
                }

                span {
                    line-height: 15px;
                }

                .mediaI {
                    font-size: 16px;
                    margin-top: 6px;
                }
            }
        }
    }

    .my-card-header {
        position: relative;

        .more-btn {
            position: absolute;
            font-size: 12px;
            top: 10px;
            right: 20px;
            cursor: pointer;
            color: rgba(51, 51, 51, 1);
            padding: 10px 0;
        }
    }
}

.padding-hide {
    padding-top: 0 !important;
}</style>
